/* eslint-disable @nrwl/nx/enforce-module-boundaries */
import { observer } from 'mobx-react';
import { Box } from '@material-ui/core';
import { LoanProcess } from '@roc/feature-utils';
import { DocumentForms, useDocumentStore } from '@roc/feature-documents';
import { TaskTodoCardCompponent } from '@roc/feature-loan-details';

interface ExtensionTodosProps {
  loanId: number;
  extensionId: number;
}

export const ExtensionTodos = observer(({ loanId, extensionId }: ExtensionTodosProps) => {
  const { documentStore } = useDocumentStore();
  const loanProcess = LoanProcess.EXTENSIONS;

  const todos =
    documentStore.loanTodosStore.todosByLoanProcess[loanProcess] ??
    [];

  return (
    <Box>
      <TaskTodoCardCompponent
        showFileName
        todos={todos}
        showDownloadTodo
        showSectionActions
        showActions={true}
        showDateColumn={true}
        showStatusColumn={true}
        loanProcess={loanProcess}
        showAssigneeColumn={true}
      />
      <DocumentForms loanId={loanId?.toString()} />
    </Box>
  );
});
